import { useCallback, useMemo } from 'react';

import * as events from 'src/lib/events';
import { PAGES, useTrackingEvent } from 'src/services/useTrackingEvent';

export const useEvents = () => {
  const trackingEvent = useTrackingEvent();

  const trackCloseClick = useCallback(() => {
    trackingEvent(events.PROJECT.clickedInsightsPanelHintClose, { page: PAGES.onboarding });
  }, [trackingEvent]);

  return useMemo(
    () => ({
      trackCloseClick,
    }),
    [trackCloseClick]
  );
};
